module.exports = __webpack_public_path__ + "img/radio-icon-default.8ab9b4e5.png";